import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenNumber'
})
export class ShortenNumberPipe implements PipeTransform {

  // from Google Gemini
  transform(value: number | null | undefined, args?: any): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    if (value < 1000) {
      return value.toString();
    }

    const suffixes = ['', 'K', 'M', 'B', 'T']; // K = Thousands, M = Millions, B = Billions, T = Trillions
    const i = Math.floor(Math.log(value) / Math.log(1000));
    const formattedValue = parseFloat((value / Math.pow(1000, i)).toFixed(1)); // Keep one decimal place

    return formattedValue + suffixes[i];
  }

}
